import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('accounts');
    const userToken = JSON.parse(tokenString);
    return userToken
  };

  const [accounts, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('accounts', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    accounts
  }
}